// Navigation.js
import React from "react";
import { Link } from "react-router-dom";

function Navigation() {
  return (
    <nav>
      <ul>
        <li>
          <Link to="/">Secure Web Craft</Link> {/* Use correct paths */}
        </li>
        <li>
          <Link to="/AboutUs">About</Link>
        </li>
        <li>
          <Link to="/Analyzer">Security Scanner</Link>
        </li>
        <li>
          <Link to="/Contact">Contact</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navigation;
